import React from 'react';
import { useSelector } from 'react-redux';

// components
import { MultiCheck, TextBlock } from '../components/inputs';
import { FormRow } from '../components/layout';

function RaceEthnicity() {
  const { race, ethnicity } = useSelector(store => store.options);

  return (
    <div>
      <FormRow>
        <TextBlock name="race_ethnicity_text_block" />
        <MultiCheck
          boldLabel
          label="Would you like to provide your race?"
          name="race"
          unsetOthersOnSelected={['999']}
          options={race}
        />
      </FormRow>

      <FormRow>
        <MultiCheck
          boldLabel
          label="Would you like to provide your ethnicity?"
          name="ethnicity"
          unsetOthersOnSelected={['NR']}
          options={ethnicity}
        />
      </FormRow>
    </div>
  );
}

export default RaceEthnicity;
